import { createAction, props } from '@ngrx/store';
import { MailboxMessageInput } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { MailboxMessageDetailSaveEvent } from '../models/mailbox-message-detail-save-event';
import { SaveMailboxMessage } from '../queries/generated/SaveMailboxMessage';

export const saveMailboxMessageDetail = createAction(
   '[Mailbox Message Detail] Save',
   props<MailboxMessageDetailSaveEvent>()
);

export const deleteMailboxMessageDetail = createAction(
   '[Mailbox Message Detail] Delete',
   props<{ mailboxMessageId: number }>()
);

export const saveMailboxMessageDetailSuccess = createAction(
   '[Mailbox Message Detail] Save Success',
   props<{ data: SaveMailboxMessage; mailboxMessageFields: (keyof MailboxMessageInput)[] }>()
);

export const saveMailboxMessageDetailFailure = createAction(
   '[Mailbox Message Detail] Save Failure',
   props<SingleGraphError>()
);

export const deleteMailboxMessageDetailSuccess = createAction(
   '[Mailbox Message Detail] Delete Success',
   props<{ mailboxMessageId: number }>()
);

export const deleteMailboxMessageDetailFailure = createAction(
   '[Mailbox Message Detail] Delete Failure',
   props<SingleGraphError>()
);

export const clearMailbox = createAction(
   '[Mailbox Message Detail] Clear Mailbox',
   props<{ mailboxMessageIds: number[] }>()
);

export const clearMailboxConfirmed = createAction('[Mailbox Message Detail] Clear Mailbox Confirmed');

export const clearMailboxSuccess = createAction(
   '[Mailbox Message Detail] Clear Mailbox Success',
   props<{ mailboxMessageIds: number[] }>()
);

export const clearMailboxFailure = createAction(
   '[Mailbox Message Detail] Clear Mailbox Failure',
   props<SingleGraphError>()
);

export const resetMailbox = createAction(
   '[Mailbox Message Detail] Reset Mailbox',
   props<{ mailboxId: number; mailboxMessageIds: number[] }>()
);

export const resetMailboxSuccess = createAction(
   '[Mailbox Message Detail] Reset Mailbox Success',
   props<{ mailboxId: number; mailboxMessageIds: number[] }>()
);

export const resetMailboxFailure = createAction(
   '[Mailbox Message Detail] Reset Mailbox Failure',
   props<SingleGraphError>()
);

export const markUnreadMailboxMessage = createAction(
   '[Mailbox Message Detail] Mark Unread',
   props<{ mailboxMessageId: number;
      mailboxFolderId?: MailboxMessageInput['mailboxFolderId'];
    }>()
);

export const markUnreadMailboxMessageSuccess = createAction(
   '[Mailbox Message Detail] Mark Unread Success',
   props<{ mailboxMessageId: number }>()
);

export const markUnreadMailboxMessageFailure = createAction(
   '[Mailbox Message Detail] Mark Unread Failure',
   props<SingleGraphError>()
);